import React from "react";
import styles from "./Layout.module.scss";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import { Outlet } from "react-router-dom";
import Message from "../../components/Message/Message";
import { useGetAllCountriesQuery } from "../../api/queries";

const Layout = () => {
  const {} = useGetAllCountriesQuery();

  return (
    <div className={styles.container}>
      <Message />
      <Sidebar />
      <div className={styles.wrapper}>
        <Header />
        <>
          <Outlet />
        </>
      </div>
    </div>
  );
};

export default Layout;
